export enum SystemNotificationIntervalTypeEnum {
  DAYS = 'days',
  HOURS = 'hours',
  MINUTES = 'minutes'
}
